export function setDocumentTitleForRoute(route) {
    if (typeof document === "undefined") return;
    const title = route?.meta?.title;
    document.title = title ? `${title} · Forkto` : "Forkto";
}
